import { useMemo } from 'react';
import { cn } from '@/shared/utils/cn';
import {
  getVisiblePdpCertifications,
  type PdpCertificationItem,
} from '../data/pdpCertifications.data';

interface PdpGalleryCertificationProps {
  metalType: string;
  diamondStoneType: string | null;
  solitaireTotalNoOfStones: number | null;
  className?: string;
  onCertificationClick?: (certificationName: string) => void;
}

function CertificationLogo({
  certification,
  onCertificationClick,
}: {
  certification: PdpCertificationItem;
  onCertificationClick?: (certificationName: string) => void;
}) {
  return (
    <a
      href={certification.href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={certification.label}
      onClick={() => onCertificationClick?.(certification.label)}
    >
      <img
        src={certification.image}
        alt={certification.label}
        className="block h-auto max-h-[28px] max-w-[110px] object-contain"
      />
    </a>
  );
}

export function PdpGalleryCertification({
  metalType,
  diamondStoneType,
  solitaireTotalNoOfStones,
  className,
  onCertificationClick,
}: PdpGalleryCertificationProps) {
  const certifications = useMemo(
    () =>
      getVisiblePdpCertifications({
        metalType,
        diamondStoneType,
        solitaireTotalNoOfStones,
      }),
    [metalType, diamondStoneType, solitaireTotalNoOfStones]
  );

  if (certifications.length === 0) return null;

  return (
    <div
      className={cn(
        'hidden items-center justify-center gap-6 py-4 md:flex',
        className
      )}
    >
      <span className="shrink-0 text-xs font-semibold uppercase tracking-wide text-[#1a2b6d]">
        Certified by
      </span>
      {certifications.map((certification) => (
        <CertificationLogo
          key={certification.id}
          certification={certification}
          onCertificationClick={onCertificationClick}
        />
      ))}
    </div>
  );
}
